import { render } from "./iconChat.vue?vue&type=template&id=6a66d869&scoped=true"
import script from "./iconChat.vue?vue&type=script&lang=ts"
export * from "./iconChat.vue?vue&type=script&lang=ts"

import "./iconChat.vue?vue&type=style&index=0&id=6a66d869&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6a66d869"

export default script